import { BaseWebComponentView } from '../../../../framework/BaseWebComponentView';
import { IntegrityMonitorAssignRulesFormWebComponentSchema } from '../types';
import { TemplateState } from '../../../../types/common/types';
import { GzTextWebComponent } from '../../../../ui/gzText';
import { GzTitleWebComponent } from '../../../../ui/gzTitle';
import { GzButtonWebComponent } from '../../../../ui/gzButton';
import { GzEnumFilterWebComponent } from '../../../../ui/gzEnumFilter';
import { EnumListItem } from '../../../../ui/gzEnumList/types';

export class IntegrityMonitorAssignRulesFormView extends BaseWebComponentView {
  public dom: {
    $wrapper: HTMLElement;
    $title: GzTitleWebComponent;
    $description: GzTextWebComponent;
    $ruleSetsSelector: GzEnumFilterWebComponent;
    $assignButton: GzButtonWebComponent;
    $cancelButton: GzButtonWebComponent;
  };

  getDomElements() {
    this.dom = {
      $wrapper: this.shadow.querySelector('.wrapper'),
      $title: this.shadow.querySelector('#assign-rules-title'),
      $description: this.shadow.querySelector('#assign-rules-description'),
      $ruleSetsSelector: this.shadow.querySelector('#assign-rules-rule-sets-selector'),
      $assignButton: this.shadow.querySelector('#assignButton'),
      $cancelButton: this.shadow.querySelector('#cancelButton'),
    };

    this.setLoadingState();
    this.getTranslations();
    this.setTranslatedStrings();
  }

  setLoadingState(): void {
    this.resetTemplateState(this.dom.$wrapper);
    this.setTemplateState(this.dom.$wrapper, TemplateState.LOADING);
  }

  removeLoadingState(): void {
    this.resetTemplateState(this.dom.$wrapper);
  }

  getTranslations() {
    this.commonStrings = this.stringsTranslator.getCommonStrings();
    this.translations = this.stringsTranslator.getIntegrityMonitorStrings().integrityMonitorRules.assignRulesForm;
  }

  setTranslatedStrings() {
    this.dom.$title.innerText = this.translations.title;
    this.dom.$description.innerText = this.translations.description;

    this.dom.$ruleSetsSelector.placeholder = this.translations.select;
    this.dom.$ruleSetsSelector.searchPlaceholderString = this.translations.search;
    this.dom.$ruleSetsSelector.confirmActionButtonString = this.commonStrings.apply;
    this.dom.$ruleSetsSelector.noSearchResultsString = this.translations.noRuleSetsFound;
    this.dom.$ruleSetsSelector.errorMessage = this.translations.errorLoadRuleSets;
    this.dom.$ruleSetsSelector.allItemsLabel = this.translations.allRuleSets;

    this.dom.$assignButton.innerText = this.translations.assign;
    this.dom.$cancelButton.innerText = this.commonStrings.cancel;
  }

  buildSuccessView(data: IntegrityMonitorAssignRulesFormWebComponentSchema) {
    this.dom.$ruleSetsSelector.filterOptions = data.ruleSetOptions
      .map(ruleSet => {
        return {
          label: ruleSet.name,
          value: ruleSet._id,
          selected: false,
        } as EnumListItem;
      })
      .sort((ruleSet1: EnumListItem, ruleSet2: EnumListItem) => {
        const name1 = ruleSet1.label.toLocaleLowerCase();
        const name2 = ruleSet2.label.toLocaleLowerCase();

        return name1 === name2 ? 0 : name1 > name2 ? 1 : -1;
      });
    this.dom.$ruleSetsSelector.disabled = false;
    this.setDisabledAssignButton(true);
    this.removeLoadingState();
  }

  buildErrorView(error: Error) {
    console.error(error);
    this.resetTemplateState(this.dom.$wrapper);
    this.setTemplateState(this.dom.$wrapper, TemplateState.ERROR);
  }

  public setDisabledAssignButton(disabled: boolean) {
    this.dom.$assignButton.disabled = disabled;
  }
}
